<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-05 10:36:03
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-11 10:46:07
 * @FilePath: /chaoyongtuan/src/views/shopManage/addMaterial/components/good/goods.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="pt-20 main-content-padding">
		<Panel :content-padding-top="20">
			<BreadCrumb slot="header"></BreadCrumb>
			<Tip :type="'warning'" class="tips-content">
				<div class="ml-6 font-h6-regular yx-color-text-primary cursor-pointer" slot="content">
					为达人提供创作参考，添加后将在[超汇选小程序] 商品详情页展示(本地素材可供达人下载）
					<el-popover placement="bottom" width="316" trigger="hover">
						<div class="p-8">
							<div class="font-h4-medium yx-color-text-primary mb-2">关联素材</div>
							<div class="font-h6-regular yx-color-text-regular">与商品相关联的素材将在小程序【商品详情】内展示，设置为【置顶】的素材将优先展示</div>
							<div class="flex-row flex-just-center">
								<img style="width: 182px" src="@/assets/public/mg-shopLibraryAddMaterial-example.png" alt="" />
							</div>
						</div>	
						<span slot="reference" class="view-examples">查看示例</span>
					</el-popover>
				</div>
			</Tip>
			<PanelHeader class="mt-20" :btnText="btnText" @btnClick="btnClick">
				<template slot="title">商品信息</template>
				<template slot="count">
					{{ goodsLength }}
				</template>
			</PanelHeader>
			<base-table
				v-loading="loading"
				class="mt-12"
				:ref="`multiTable`"
				:columns="columns"
				:cellStyle="cellStyle"
				:page="pageInfo"
				:spanMethod="spanMethod"
				:pageFixed="false"
				:list="list"
				:total="total"
			>
				<empty slot="empty" >
					<p slot="desc">暂无推广中活动商品</p>
				</empty>
			</base-table>
			<yx-pagination
				:total="total"
				:current-page="pageInfo.page_index"
				:page-size="pageInfo.page_size"	
				layout="total, prev, pager, next"
				@current-change="currentChange"
			/>
			<!--添加商品抽屉-->
			<AddDrawer ref="addDrawer" @addData="updateTableData" />
		</Panel>
	</div>
</template>
<script>
import PanelHeader from '../panelHeader';

import { materialProductList } from '@/api/shopManage';
import { uniq, uniqWith } from 'lodash';
import getColumns from './columns.js';
import AddDrawer from './addDrawer.vue';
export default {
	components: {
		PanelHeader,
		AddDrawer,
	},
	provide() {
		return {
			injectSettingComssion: row => this.settingComssion(row),
			injectUpdateTableData: row => this.updateTableData(row, 'remove'),
		};
	},

	props: {
		isBatch: {
			type: Boolean,
			default: false,
		},
		queryParams: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			loading: false, //loading 状态
			pageInfo: {
				page_index: 1,
				page_size: 5,
			}, //分页
			total: 0, //总页数
			list: [], // 处理后 渲染table列表数据
			defaultList: [], //处理前 列表的数据
			selectProductId: [], //设为公开佣金率保存的商品id数组
		};
	},
	created() {
		this.getList();
	},
	computed: {
		btnText() {
			return this.isBatch ? '添加商品' : null;
		},
		columns() {
			return getColumns(this);
		},
		goodsLength() {
			return this.defaultList.length || 0;
		},
	},
	methods: {
		/**
		 * 添加/删除事件
		 */
		updateTableData(data, opType) {
			const operates = {
				add: () => data.concat(JSON.parse(JSON.stringify(this.defaultList))),
				remove: () => this.defaultList.filter(item => item.thirdProductId != data.goodsInfo.mainId),
			};
			this.cacheData();
			this.defaultList = operates[opType]?.() || [];
			if(opType === 'add') this.defaultList = uniqWith(JSON.parse(JSON.stringify(this.defaultList)),(a,b)=> a.thirdProductId == b.thirdProductId);
			this.pageInfo.page_index = 1;
			this.total = this.goodsLength;
			this.sliceTotalData();
			opType === 'remove' && this.$message.success('移除成功');
		},

		/**
		 * 获取商品信息的列表
		 */
		async getList() {
			this.loading = true;
			try {
				const { platformId , thirdProductId} = this.queryParams;
				let third_product_ids = this.isBatch ? JSON.parse(localStorage.getItem('goodsList')) : thirdProductId;
				const { list } = await materialProductList({ ...this.pageInfo, platform_id: platformId, third_product_ids });
				this.defaultList = list;
				this.total = list.length;
				this.loading = false;
				this.sliceTotalData();
			} finally {
				this.loading = false;
			}
		},
		/**
		 * 处理数据
		 */
		fomatData(list) {
			let retList = [];
			list.map(val => {
				if (val.productInfo.length > 4) {
					val.multiterm = val.productInfo.length > 4 ? val.productInfo.slice(3, val.productInfo.length) : [];
					val.productInfo = val.productInfo.length > 4 ? val.productInfo.slice(0, 3) : val.productInfo;
				}
				if (val.multiterm && val.multiterm.length) {
					val.productInfo.push({
						count: val.multiterm.length,
						multiterm: val.multiterm.map(v => {
							v.thirdProductId = val.thirdProductId;
							return v;
						}),
						type: 1,
						platformId: val.platformId,
					});
				}
			});
			list.forEach(item => {
				const { productInfo, ...rest } = item;
				productInfo.forEach(follower => {
					const retItem = {
						goodsInfo: {
							mainId: item.thirdProductId,
							...rest,
						},
						type: 0,
						thirdProductId: item.thirdProductId,
						platformId: item.platformId,
						productPic: item.productPic,
						...follower,
					};
					retList.push(retItem);
				});
			});
			return retList;
		},
		// 添加商品前 把之前设置的商品配置都保存下
		cacheData() {
			this.defaultList.map((val)=>{
				val.productInfo.map((v)=>{
					if (+val.hasOpenCommissionRate === 1) {
						this.selectProductId.push(v.productId);
					}
				})
			})
		},

		// 获取表格合并数据
		getSpan(list) {
			const newArr = [];
			const obj = {};
			for (let i = 0; i < list.length; i++) {
				if (i === 0) {
					obj.row = 1;
					obj.col = 1;
					newArr.push(obj);
				} else {
					if (list[i].goodsInfo.mainId === list[i - 1].goodsInfo.mainId) {
						newArr.push({ row: 0, col: 0 });
						const index = list.findIndex(item => {
							return item.goodsInfo.mainId === list[i - 1].goodsInfo.mainId;
						});
						newArr[index].row++;
					} else {
						newArr.push({ row: 1, col: 1 });
					}
				}
			}
			return newArr;
		},
		// 表格合并
		spanMethod({ row, column, rowIndex, columnIndex }) {
			const arr = this.getSpan(this.list);
			if ([0, 6, 7].includes(columnIndex)) {
				const row = arr[rowIndex].row;
				const col = arr[rowIndex].col;
				return {
					rowspan: row,
					colspan: col,
				};
			}
		},
		// 页码调整
		currentChange(val) {
			this.defaultList.map(val => {
				val.isEdit = 1;
			});
			this.pageInfo.page_index = val;
			this.sliceTotalData();
		},
		/**
		 * 本地处理数据分页
		 */
		sliceTotalData() {
			const { page_index, page_size } = this.pageInfo;
			let selectId = uniq(this.selectProductId);
			const startIndex = page_index === 1 ? 0 : (page_index - 1) * page_size;
			this.defaultList.map(item => {
				item.productInfo.map((v)=>{
					if (selectId.includes(v.productId)) {
						v.hasOpenCommissionRate = 1;
					}
				})
			});
			this.list = this.fomatData(JSON.parse(JSON.stringify(this.defaultList.slice(startIndex, page_size * page_index))));
		},
		/**
		 * 合并表格 增加一边框的样式
		 */
		cellStyle({ row, column, rowIndex, columnIndex }) {
			if ([1, 6, 7].includes(columnIndex)) {
				return {
					'border-left': '1px solid #ebeef5',
				};
			}
		},

		/**
		 * 按钮点击
		 */
		btnClick() {
			this.$refs.addDrawer.show(this.defaultList);
		},

		/**
		 * 设为公开佣金率 并置顶
		 */
		async settingComssion(obj) {		
			const index = this.defaultList.filter((val)=> val.thirdProductId == obj.thirdProductId)[0]?.productInfo.findIndex((v)=> v.productId == obj.productId);
			this.defaultList.filter((val)=> val.thirdProductId == obj.thirdProductId)[0].productInfo.splice(index, 1);
			obj.hasOpenCommissionRate = 1;
			this.defaultList.filter((val)=> val.thirdProductId == obj.thirdProductId)[0].productInfo.unshift(obj);
			this.defaultList.filter((val)=> val.thirdProductId == obj.thirdProductId)[0].productInfo.map((val, i)=>{
			    if(val.productId != obj.productId){
					val.hasOpenCommissionRate = 0;
				}
			})
			this.sliceTotalData();
			this.$message.success('置顶成功')
		},
		// 父组件 获取数据
		getData(){
			let product_infos = [];
			let list =  this.fomatData(JSON.parse(JSON.stringify(this.defaultList)))
			list.map((val)=>{
				if( +val.hasOpenCommissionRate ){
					product_infos.push({
						product_id: val.productId,
						third_product_id: val.thirdProductId,
						has_open_commission_rate: 1
					})
				}
			})
			return product_infos;
		}
	},
};
</script>
<style lang="less" scoped>
.view-examples {
	color: #ff7038;
}
.tips-content {
	/deep/ .el-icon-info {
		top: 1px !important;
	}
}
</style>
